module.exports = __webpack_public_path__ + "assets/koha.ea9b1876.svg";